import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { GrnRejectionReason } from "../grn-rejection-reason.entity";
import { RejectionReasonsDto } from "./grn-rejection-reasons.dto";

export class GrnRejectionReasonAdapter {
    convertDtoToEntity(dtoObj: RejectionReasonsDto,  isUpdate: boolean = false ): GrnRejectionReason {
        try {
            const entityObj = new GrnRejectionReason();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.rejectionReason = dtoObj.rejectionReason;
            entityObj.rejectionReasonCode = dtoObj.rejectionReasonCode;
            entityObj.remarks = dtoObj.remarks;
            if (dtoObj.rejectionReasonId) {
                entityObj.rejectionReasonId = dtoObj.rejectionReasonId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: GrnRejectionReason): RejectionReasonsDto {
        const foodTypeDetailsDTO= new RejectionReasonsDto;
        foodTypeDetailsDTO.rejectionReasonId = employeeObject.rejectionReasonId;
        foodTypeDetailsDTO.rejectionReason = employeeObject.rejectionReason;
        foodTypeDetailsDTO.rejectionReasonCode= employeeObject.rejectionReasonCode;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}